import { render, staticRenderFns } from "./alert-bar.vue?vue&type=template&id=057c2a30&scoped=true"
import script from "./alert-bar.vue?vue&type=script&lang=js"
export * from "./alert-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057c2a30",
  null
  
)

export default component.exports